/* Reproduce the source tracking video's central play action without changing video or poster URLs. */
(() => {
 const policyTitles={'privacy-policy':'Política de privacidad','terms-of-service':'Términos y condiciones','refund-policy':'Devoluciones y cambios','shipping-policy':'Información de envío','subscription-policy':'Política de suscripción','contact-information':'Información de contacto'};
 function initialize(scope=document){
  const policy=location.pathname.match(/\/policies\/([a-z-]+)\/?$/),heading=scope.querySelector('.shopify-policy__title h1');
  if(policy&&heading&&policyTitles[policy[1]])heading.textContent=policyTitles[policy[1]];
  scope.querySelectorAll('.gr-reference-content .way-video').forEach(wrapper=>{
   const video=wrapper.querySelector('video'),button=wrapper.querySelector('.play-btn');
   if(!video||!button||button.dataset.grMediaReady)return;
   button.dataset.grMediaReady='true';button.setAttribute('role','button');button.setAttribute('tabindex','0');button.setAttribute('aria-label','Reproducir vídeo');
   video.controls=true;video.setAttribute('playsinline','');
   const hide=()=>{button.style.display='none';button.setAttribute('aria-hidden','true');};
   const show=()=>{button.style.display='';button.removeAttribute('aria-hidden');};
   const play=async()=>{try{await video.play();hide();}catch{show();}};
   button.addEventListener('click',play);button.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();play();}});
   video.addEventListener('play',hide);video.addEventListener('ended',show);
  });
 }
 document.addEventListener('DOMContentLoaded',()=>initialize());document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
